/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteRiderEvents } from '../fn/rider-events/delete-rider-events';
import { DeleteRiderEvents$Params } from '../fn/rider-events/delete-rider-events';
import { racesRaceGuidHorsecombinationsHorseCombinationNumberRidersRidereventsPost } from '../fn/rider-events/races-race-guid-horsecombinations-horse-combination-number-riders-riderevents-post';
import { RacesRaceGuidHorsecombinationsHorseCombinationNumberRidersRidereventsPost$Params } from '../fn/rider-events/races-race-guid-horsecombinations-horse-combination-number-riders-riderevents-post';
import { RiderEvent } from '../models/rider-event';
import { riderEventsOnlyReportable } from '../fn/rider-events/rider-events-only-reportable';
import { RiderEventsOnlyReportable$Params } from '../fn/rider-events/rider-events-only-reportable';

@Injectable({ providedIn: 'root' })
export class RiderEventsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `riderEventsOnlyReportable()` */
  static readonly RiderEventsOnlyReportablePath = '/races/{raceGuid}/onlyreportable/{onlyReportable}/riderevents';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `riderEventsOnlyReportable()` instead.
   *
   * This method doesn't expect any request body.
   */
  riderEventsOnlyReportable$Response(params: RiderEventsOnlyReportable$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RiderEvent>>> {
    const obs = riderEventsOnlyReportable(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `riderEventsOnlyReportable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  riderEventsOnlyReportable(params: RiderEventsOnlyReportable$Params, context?: HttpContext): Observable<Array<RiderEvent>> {
    const resp = this.riderEventsOnlyReportable$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<RiderEvent>>): Array<RiderEvent> => r.body)
    );
  }

  /** Path part for operation `racesRaceGuidHorsecombinationsHorseCombinationNumberRidersRidereventsPost()` */
  static readonly RacesRaceGuidHorsecombinationsHorseCombinationNumberRidersRidereventsPostPath = '/races/{raceGuid}/horsecombinations/{horseCombinationNumber}/riders/riderevents';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `racesRaceGuidHorsecombinationsHorseCombinationNumberRidersRidereventsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  racesRaceGuidHorsecombinationsHorseCombinationNumberRidersRidereventsPost$Response(params: RacesRaceGuidHorsecombinationsHorseCombinationNumberRidersRidereventsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<RiderEvent>> {
    const obs = racesRaceGuidHorsecombinationsHorseCombinationNumberRidersRidereventsPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `racesRaceGuidHorsecombinationsHorseCombinationNumberRidersRidereventsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  racesRaceGuidHorsecombinationsHorseCombinationNumberRidersRidereventsPost(params: RacesRaceGuidHorsecombinationsHorseCombinationNumberRidersRidereventsPost$Params, context?: HttpContext): Observable<RiderEvent> {
    const resp = this.racesRaceGuidHorsecombinationsHorseCombinationNumberRidersRidereventsPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RiderEvent>): RiderEvent => r.body)
    );
  }

  /** Path part for operation `deleteRiderEvents()` */
  static readonly DeleteRiderEventsPath = '/races/{raceGuid}/riders/{riderGuid}/riderevents';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteRiderEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRiderEvents$Response(params: DeleteRiderEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteRiderEvents(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteRiderEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRiderEvents(params: DeleteRiderEvents$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteRiderEvents$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
